"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_32_1_2 = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
/**
 * Migrate to 32.2.1
 *
 * Leitung.IsBeschriftungTextManuallyChanged has been added for [EKE-4053] Optimise labelling
 * option.
 *
 *  After this change the Leitung have to follow this tow rules
 *
 *  If Leitung has a BeschriftungText it must have a LeitungBeschriftung.folienlabel
 *   &
 *  If BeschriftungText not equal to IAIndex IsBeschriftungTextManuallyChanged must be true
 *
 */
const migration_32_1_2 = (json) => {
    if (json.Leitungen) {
        json.Leitungen = json.Leitungen.map((l) => {
            if (l.BeschriftungText && l.Beschriftung === echain_shared_articles_1.LeitungBeschriftung.keine) {
                l.Beschriftung = echain_shared_articles_1.LeitungBeschriftung.folienlabel;
            }
            if (l.BeschriftungText !== l.IAIndex && l.Beschriftung === echain_shared_articles_1.LeitungBeschriftung.folienlabel) {
                l.IsBeschriftungTextManuallyChanged = true;
            }
            return l;
        });
    }
    return json;
};
exports.migration_32_1_2 = migration_32_1_2;
//# sourceMappingURL=migration_32_1_2.js.map